import { render, staticRenderFns } from "./WorkflowFormBuilderRevisionGrantAccessTargetFormDialog.vue?vue&type=template&id=3f69ccc5&"
import script from "./WorkflowFormBuilderRevisionGrantAccessTargetFormDialog.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormBuilderRevisionGrantAccessTargetFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports